import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ArrowsChevronUpRegularIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M5.436 16c-.176-.001-.335-.119-.403-.299-.067-.18-.03-.387.094-.525l6.255-6.893c.165-.183.384-.283.617-.283.234 0 .454.1.619.282l6.255 6.894c.124.138.161.345.094.525-.068.18-.227.298-.403.299-.116 0-.228-.05-.31-.141L12 8.965l-6.255 6.894c-.081.09-.193.141-.309.141z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ArrowsChevronUpRegularIcon = __decorateClass([
  customElement("elm-arrows-chevron-up-regular-icon")
], ArrowsChevronUpRegularIcon);
export { ArrowsChevronUpRegularIcon };
